import React, { createContext, useContext, useState } from "react";
import {
  Reit,
  InvitsParameters,
  ParametersContextType,
  ReitSummary,
} from "../types/reit.types";
import { Invit, InvitSummary, InvitParameters } from "../types/invit.types";

const ParametersContext = createContext<ParametersContextType | undefined>(
  undefined
);

export const ParametersProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  // Reits
  const [parameters, setParameters] = useState<InvitsParameters[]>([]);
  const [reits, setReits] = useState<Record<string, Reit>>({});
  const [reitSummary, setReitSummary] = useState<ReitSummary[]>([]);
  const [currentReit, setCurrentReit] = useState<Reit | null>(null);

  // Invits
  const [invitParameters, setInvitParameters] = useState<InvitParameters[]>([]);
  const [invits, setInvits] = useState<Record<string, Invit>>({});
  const [invitSummary, setInvitSummary] = useState<InvitSummary[]>([]);
  const [currentInvit, setCurrentInvit] = useState<Invit | null>(null);

  // Shared
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [activeToggle, setActiveToggle] = useState<string>("Public");

  return (
    <ParametersContext.Provider
      value={{
        // Reits
        parameters,
        setParameters,
        reits,
        setReits,
        reitSummary,
        setReitSummary,
        currentReit,
        setCurrentReit,

        invitParameters,
        setInvitParameters,
        invits,
        setInvits,
        invitSummary,
        setInvitSummary,
        currentInvit,
        setCurrentInvit,

        isLoading,
        setIsLoading,

        activeToggle,
        setActiveToggle,
      }}
    >
      {children}
    </ParametersContext.Provider>
  );
};

export const useParameters = (): ParametersContextType => {
  const context = useContext(ParametersContext);
  if (!context) {
    throw new Error("useParameters must be used within ParametersProvider");
  }
  return context;
};
